export const content = `We use the answers you provided during the matching process when you first created your BetterHelp account. We match you with a therapist based on:

- Your state
- Your insurance (if you're looking for in-network care)
- Your reasons for visiting
- Any additional preferences you shared, such as gender, race or ethnicity, and community experiences, based therapist availability
`;
